import { Injectable } from '@angular/core';
import {
  ActionSheetController,
  AlertController,
  LoadingController,
  ModalController,
  Platform,
  ToastController
} from '@ionic/angular';

import { AOString } from '../utils/ao-string';
import { AOContainerService } from '../directives/ao-container/ao-container.service';
import { AOMenuService } from '../services/ao-menu.service';

@Injectable({
  providedIn: 'root'
})
export class AOService {

  constructor(
    public platform: Platform,
    public ionLoading: LoadingController,
    public ionAlert: AlertController,
    public ionModal: ModalController,
    public ionSheet: ActionSheetController,
    public ionToast: ToastController,
    public menu: AOMenuService,
    public container: AOContainerService,
  ) {
  }

  //--------------------------------------------------------------------------------------------------------------------
  // LOADING
  //--------------------------------------------------------------------------------------------------------------------

  wait(promise: Promise<any>, opts: any = {}) {
    return this.ionLoading.create({message: 'Carregando...', ...opts}).then(loading => {

      return loading.present().then(() => {

        promise.finally(() => loading.dismiss());
        return promise;

      });

    });
  }

  //--------------------------------------------------------------------------------------------------------------------
  // DROPDOWN
  //--------------------------------------------------------------------------------------------------------------------

  sheet(buttons: any = {}, opts: any = {}) {
    return this.ionSheet.create({header: 'OpÃ§Ãµes...', buttons, ...opts}).then(sheet => {

      return sheet.present().then(() => {

        return sheet;

      });

    });
  }

  //--------------------------------------------------------------------------------------------------------------------
  // MODAL
  //--------------------------------------------------------------------------------------------------------------------

  modal(component, opts: any = {}) {
    return this.ionModal.create({component, ...opts}).then(modal => {

      return modal.present().then(() => {

        return modal;

      });

    });
  }

  //--------------------------------------------------------------------------------------------------------------------
  // ALERT
  //--------------------------------------------------------------------------------------------------------------------

  alert(message: string, opts: any = {}) {
    return this.ionAlert.create(
      {
        header: 'AtenÃ§Ã£o...',
        message,
        buttons: [
          {text: 'OK', role: 'OK'}
        ],
        ...opts
      }
    ).then(alert => {

      return alert.present().then(() => {

        return alert.onDidDismiss();

      });

    });
  }

  //--------------------------------------------------------------------------------------------------------------------
  // PROMPT
  //--------------------------------------------------------------------------------------------------------------------

  prompt(inputs: any[], opts: any = {}) {
    return this.alert('', {
      header: 'Preencha...',

      inputs,

      buttons: [
        {text: 'CANCELAR', role: 'CANCEL'},
        {text: 'OK', role: 'OK'}
      ],

      ...opts
    });
  }

  //--------------------------------------------------------------------------------------------------------------------
  // CONFIRM
  //--------------------------------------------------------------------------------------------------------------------

  confirm(message: string, yes = () => null, no = () => null, opts: any = {}) {
    return this.alert(message, {

      header: 'ConfirmaÃ§Ã£o...',

      buttons: [
        {text: 'NÃO', role: 'NO'},
        {text: 'SIM', role: 'YES'}
      ],

      ...opts

    }).then(response => {

      response.role == 'YES' ? yes() : no();
      return response;

    });
  }

  confirmOperation(yes = () => null, no = () => null, opts: any = {}) {
    return this.confirm('Deseja realmente <b>realizar</b> esta operaÃ§Ã£o?', yes, no, opts);
  }

  confirmActivate(yes = () => null, no = () => null, opts: any = {}) {
    return this.confirm('Deseja realmente <b>ativar</b> este item?', yes, no, opts);
  }

  confirmDeactivate(yes = () => null, no = () => null, opts: any = {}) {
    return this.confirm('Deseja realmente <b>desativar</b> este item?', yes, no, opts);
  }

  confirmDestroy(yes = () => null, no = () => null, opts: any = {}) {
    return this.confirm('Deseja realmente <b>excluir</b> este item?', yes, no, opts);
  }

  //--------------------------------------------------------------------------------------------------------------------
  // TOAST
  //--------------------------------------------------------------------------------------------------------------------

  toast(message: string, opts: any = {}) {
    return this.ionToast.create({
      message,
      duration: AOString.readingTime(message),
      ...opts
    }).then(toast => {
      return toast.present().then(() => {

        return toast.onDidDismiss();

      });
    });
  }

  info(message: string, opts: any = {}) {
    //console.info(message);
    return this.toast(message, {color: 'tertiary', ...opts});
  }

  success(message: string, opts: any = {}) {
    //console.log(message);
    return this.toast(message, {color: 'success', ...opts});
  }

  warning(message: string, opts: any = {}) {
    console.warn(message);
    return this.toast(message, {color: 'warning', ...opts});
  }

  danger(message: string, opts: any = {}) {
    console.error(message, opts.error);
    return this.toast(message, {color: 'danger', ...opts});
  }

}
